var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FrField',_vm._g(_vm._b({staticClass:"password-field"},'FrField',{..._vm.$attrs},false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }